export type { BonusReportForPlaceTranslations } from "./bonus-report-for-place-pt-br";
export { BONUS_REPORT_FOR_PLACE_PT_BR } from "./bonus-report-for-place-pt-br";
export { BONUS_REPORT_FOR_PLACE_EN_US } from "./bonus-report-for-place-en-us";
export { BONUS_REPORT_FOR_PLACE_ES_MX } from "./bonus-report-for-place-es-mx";
export { BONUS_REPORT_FOR_PLACE_FR_FR } from "./bonus-report-for-place-fr-fr";
